module.exports = __webpack_public_path__ + "static/img/page2.8ead567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doudouImg/page2.png
// module id = 0aju
// module chunks = 1